<template>
  <div id="file-outgoing-container">
    <mtd-announcement type="warning" show-icon>
      <template slot="default">
        {{ $getText('wenshu_web_module_reminder_forwarding_requirement', '温馨提示：如需外发原始文件或上传大文件，请通过文枢客户端外发报备') }}：
        <a style="color: #0a70f5;cursor: pointer;text-decoration: none" @click.stop="open_wenshu_client">
          {{ $getText('wenshu_web_module_launch_client', '【启动客户端】') }}
        </a>
      </template>
    </mtd-announcement>
    <!-- 上传标题 -->
    <mtd-row style="margin-top: 16px;">
      <mtd-col :span="24">
        <span class="dd-page-title">{{ $getText('wenshu_web_file_export', '文件外发') }}</span>
      </mtd-col>
    </mtd-row>
    <!-- 上传辅标题 -->
    <mtd-row style="margin-top: 16px;height: 22px;">
      <mtd-col :span="24">
        <span class="dd-page-subtitle">{{ $getText('wenshu_web_module_upload_file', '上传文件') }}</span>
      </mtd-col>
    </mtd-row>
    <!-- 文件上传框 -->
    <div style="margin-top: 12px;">
      <mtd-upload class="drag-upload" ref="upload" drag multiple :limit="max_limit" :show-file-list="false"
                  :before-upload="before_file_upload" :on-progress="file_on_progress" :on-success="handleUploadSuccess"
                  :on-error="handleUploadError" action="/api/distribute/fileOutgoing/fileOutUpload"
                  :file-list="file_list" :on-exceed="show_limit_message">
        <div :class="{'upload-hot-area':drag}"
             style="height: 100%;width: 100%;display: flex;align-items: center;justify-content: center">
          <div class="upload-content">
            <div class="mtd-upload-text">
              <div class="title-text">
                <span>{{ $getText('wenshu_web_drag_file_here_to_upload_or', '将文件拖至此处上传，或') }}
                  <span style="color: #0A70F5;text-decoration: underline;">{{ $getText('wenshu_web_click_to_upload', '点击上传') }}</span>
                </span>
              </div>
              <div class="tips">
                <span>{{ $getText('wenshu_web_module_web_upload_limit', {max: max_limit}, '网页版上传文件需≤100M，最多同时上传{max}个') }}</span>
              </div>
            </div>
          </div>
        </div>
      </mtd-upload>
    </div>
    <!-- 文件列表显示 -->
    <mtd-row style="margin-top: 4px" :gutter="8" v-if="file_list.length !== 0">
      <mtd-col :span="6" style="margin-top: 8px;" v-for="(item, index) in file_list" class="file-container-block"
               v-bind:class="{ 'padding-left-0': index%4===0, 'padding-right-0': index%4===3 }">
        <div class="file-item-block">
          <div class="file-type-icon"><img :src="require('@/assets/'+pictureSelect(item)+'.png')"></div>
          <div class="progress-status-container">
            <div class="file-name-div">{{ item.fileName }}</div>
            <div class="progress-div" :class="[upload_status_class(item)]">
              <mtd-icon name='bolt-fill'></mtd-icon>
              <mtd-progress :percentage="item.percentage" :stroke-width="4" class="file-upload-progress"/>
              <div class="file-upload-show-text">
                <span>{{ item.message }}</span>
              </div>
            </div>
          </div>
          <div class="delete-file-container">
            <mtd-icon-button type="secondary" icon="mtdicon mtdicon-close" @click="before_file_remove(item)"
                             v-if="item.fileStatus !== 'fail'"/>
            <mtd-icon-button class="icon-btn" icon="mtdicon mtdicon-refresh-o" @click="re_upload(item)"
                             v-if="item.fileStatus === 'fail'"/>
          </div>
        </div>
      </mtd-col>
    </mtd-row>
    <!-- 链接有效期 -->
    <mtd-row style="margin-top: 32px">
      <mtd-col :span="24">
        <span class="dd-page-subtitle">{{ $getText('wenshu_web_link_validity_selection', '选择链接有效期') }}</span>
        <span class="page-info-detail"><i class="mtdicon mtdicon-info-circle-o"/>{{ $getText('wenshu_web_validity_after_approval', '审批通过后，有效期生效，最长有效期为30天') }}</span>
      </mtd-col>
    </mtd-row>
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="24">
        <mtd-form :label-width="110">
          <mtd-form-item :label="$getText('wenshu_web_validity_period', '有效期')" style="margin-bottom: 0;">
            <mtd-select v-model="validateDays" style="width: 120px" @change="validateDays_change">
              <mtd-option :value="day.value" :label="day.label" :key="'key_'+day.value" v-for="day in default_days"/>
              <mtd-option :value="-1" :label="$getText('wenshu_web_custom', '自定义')"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!-- 外发信息 -->
    <mtd-row style="margin-top: 27px">
      <mtd-col :span="24">
        <span class="dd-page-subtitle">{{ $getText('wenshu_web_confirm_external_info', '确认外发信息') }}</span>
      </mtd-col>
    </mtd-row>
    <!-- 审批节点 -->
    <mtd-row style="margin-top: 12px" v-if="strategy_chain_list.length > 0">
      <mtd-col :span="24">
        <span>外发审批节点预览</span>
      </mtd-col>
      <mtd-col :span="24">
        <mtd-steps>
          <mtd-step :title="item" v-for="item in strategy_chain_list"/>
        </mtd-steps>
      </mtd-col>
    </mtd-row>
    <!-- 外发原因 -->
    <mtd-row style="margin-top: 12px">
      <mtd-col :span="24">
        <mtd-form label-position="top">
          <mtd-form-item label="" style="margin-bottom: 0;">
            <mtd-textarea v-model="outReason" :placeholder="this.$getText('wenshu_web_external_reason', '外发原因')" style="width: 100%;resize: none; height: 60px;"/>
          </mtd-form-item>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!-- 收件人邮箱 -->
    <mtd-row style="margin-top: 32px">
      <mtd-col>
        <mtd-checkbox v-model="email_auto_collapse">
          <span class="dd-page-subtitle">{{ $getText('ws_mobile_recipient_email_optional', '收件人邮箱') }}</span>
        </mtd-checkbox>
        <span class="page-info-detail"><i class="mtdicon mtdicon-info-circle-o"/>{{ $getText('ws_mobile_email_helper_text', '审批通过后，文件下载的链接将自动发送到填写的邮箱') }}</span>
      </mtd-col>
    </mtd-row>
    <mtd-row style="margin-top: 12px" v-if="email_auto_collapse">
      <mtd-col>
        <el-select v-model="email_list" multiple filterable allow-create style="width: 100%;border-radius: 4px"
                   default-first-option :placeholder="$getText('wenshu_web_enter_email', '请输入邮箱')">
        </el-select>
      </mtd-col>
    </mtd-row>
    <!-- 错误信息提示 -->
    <mtd-row style="margin-top: 32px" v-if="current_refuse_send_out">
      <mtd-col style="text-align: center; color: rgba(255,0,0,0.69)">
        <div><i class="mtdicon-error-circle" style="font-size: 32px"></i></div>
        <div class="dd-page-subtitle" style="margin-top: 10px;">{{ $getText('ws_mobile_hit_department_policy', '命中部门禁止外发策略') }}</div>
        <div class="dd-page-subtitle" style="color: rgba(255,0,0,0.69)">{{ $getText('ws_mobile_contact_if_questions', '如有疑问请联系') }} {{ templateContactPerson }}</div>
      </mtd-col>
    </mtd-row>
    <!-- 底部提交按钮 -->
    <mtd-row class="submit-buttons-div">
      <mtd-col :span="24">
        <mtd-button type="primary" size="large" style="margin-left: 8px" @click="submit_out"
                    :disabled="check_file_list">
          {{ $getText('ws_mobile_apply_send_out', '申请外发') }}
        </mtd-button>
      </mtd-col>
    </mtd-row>
    <!-- 文件超过大小限制 -->
    <mtd-modal v-model="hasBigFile"
               :title="text_data.oversize_text">
      <div slot="footer" class="demo-modal-footer">
        <mtd-button type="primary" @click="hasBigFile = false">{{ $getText('wenshu_web_i_know', '我知道了') }}</mtd-button>
      </div>
    </mtd-modal>
    <!-- 自定义有效期 -->
    <mtd-modal :title="$getText('wenshu_web_custom_validity_period', '自定义有效期')" v-model="custom_validate_modal" width="40%">
      <mtd-form :rules="custom_validate_rule" :model="custom_form">
        <mtd-form-item :label="$getText('wenshu_web_validity_period', '有效期') + ':'" prop="custom_validate" :label-width="110">
          <mtd-input type="text" v-model="custom_form.custom_validate" style="width: 80%;"
                     :placeholder="$getText('wenshu_web_max_validity_period_30_days_please_enter_number_1_to_30', '请输入1-30以内的数字')"/>
          {{ $getText('ws_mobile_days', '天') }}
        </mtd-form-item>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_custom_validate">{{ $getText('wenshu_web_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_custom_validate" :disabled="custom_validate_disabled">{{ $getText('wenshu_web_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: "file_out_upload",
    data() {
      const validateCustomDays = (_rule, value, callback) => {
        if (!/^[0-9]*$/.test(value)) {
          return callback(new Error(this.$getText('wenshu_web_max_validity_period_30_days_please_enter_number_1_to_30', '最长有效期为30天，请输入1-30以内的数字')));
        }
        if (value < 1 || value > 30) {
          return callback(new Error(this.$getText('wenshu_web_max_validity_period_30_days_please_enter_number_1_to_30', '最长有效期为30天，请输入1-30以内的数字')));
        }
        return callback();
      }
      return {
        text_data: {
          oversize_text: this.$getText('wenshu_web_large_file_warning', '有文件大于100M，请使用人工文件外发报备流程')
            + "<em @click='details'>" + this.$getText('wenshu_web_module_view_details', '查看详情') + "</em>",
        },
        default_days: [
          {value: 3, label: this.$getText('wenshu_mobile_3_days', '3天')},
          {value: 7, label: this.$getText('wenshu_mobile_7_days', '7天')},
          {value: 30, label: this.$getText('wenshu_mobile_30_days', '30天')}
        ],
        file_list: [],
        max_limit: 15,
        email_list: [],
        hasBigFile: false,
        drag: false,
        email_auto_collapse: null,
        outReason: null,
        validateDays: 3,
        custom_form: {
          custom_validate: null,
        },
        custom_validate_modal: false,
        custom_validate_rule: {
          custom_validate: [
            {validator: validateCustomDays, trigger: 'change'},
          ]
        },
        exempt_approval_flag: false,
        matching_strategy_result: null,
        strategy_chain_list: [],
        current_refuse_send_out: false,
        current_refuse_send_file_list: [],
        templateContactPerson: this.$getText('ws_mobile_employee_help_desk', '员工帮助台')
      }
    },
    mounted() {
      let arr = this.$route.params.file_list;
      if (arr != null && arr.length !== 0) {
        this.file_list = arr;
      }
      // 添加默认事件
      const upload_dragger = document.querySelector('.mtd-upload-dragger');
      upload_dragger.addEventListener('dragover', function () {
        this.className += 'mtd-upload-dragger drag-over';
      });
      upload_dragger.addEventListener('dragstart', function () {
        this.className = 'mtd-upload-dragger';
      });
    },
    computed: {
      check_file_list() {
        if (this.current_refuse_send_out && this.current_refuse_send_file_list && this.current_refuse_send_file_list.length > 0) {
          return true;
        }
        if (this.file_list.length <= 0) {
          return true;
        }
        if (!this.outReason || this.outReason === '') {
          return true;
        }
        for (let i = 0; i < this.file_list.length; i++) {
          if (this.file_list[i].fileStatus !== 'success') {
            return true;
          }
        }
        return false;
      },
      custom_validate_disabled() {
        if (!this.custom_form.custom_validate) {
          return true;
        }
        let custom_validate = parseInt(this.custom_form.custom_validate);
        if (custom_validate < 1 || custom_validate > 30) {
          return true;
        }
        return false;
      }
    },
    methods: {
      ...mapActions([
        'fileContentScan',
        'matchingStrategy',
        'submitFileOutOrderExemption',
        'query_bpm_approval_chain',
        'submitFileOutOrder'
      ]),
      details() {
        window.open("https://km.sankuai.com/page/18283035");
      },
      before_file_upload(data) {
        if (data.size >= 100 * 1000 * 1000) {
          this.$mtd.confirm({
            title: this.$getText('wenshu_web_warning_alert', '警告提示'),
            message: this.$getText('wenshu_web_unsupported_large_file', '有文件大于100M，请使用人工文件外发报备流程'),
            width: '400px',
            type: 'warning',
            okButtonText: this.$getText('wenshu_web_module_launch_client', '启动客户端'),
            dangerouslyUseHTMLString: true,
            onOk: () => {
              this.open_wenshu_client();
            }
          });
          return false;
        }
        var new_list = this.file_list.filter(item => {
          return item.uid === data.uid
        });
        if (new_list.length === 0) {
          // 区分重名文件
          let sameNumber = 0;
          let fileName = data.name;
          // 判断文件名是否存在
          let exist_filename = true;
          let tempName = fileName;
          while (exist_filename) {
            // 如果列表为空，直接赋值false
            if (!this.file_list || this.file_list.length === 0) {
              exist_filename = false;
              console.log(exist_filename);
              break;
            }
            for (let i = 0; i < this.file_list.length; i++) {
              if (tempName === this.file_list[i].fileName) {
                sameNumber += 1;
                exist_filename = true;
                let index = fileName.lastIndexOf(".");
                if (index !== -1) {
                  tempName = fileName.substring(0, index) + "(" + sameNumber + ")" + fileName.substring(index);
                }
                break;
              }
              exist_filename = false;
            }
          }

          let file = {
            id: '',
            fileName: tempName,
            type: data.type,
            fileStatus: '',
            percentage: 0,
            fileSize: data.size,
            uid: data.uid,
            message: this.$getText('wenshu_web_uploading', '上传中...'),
            fileGrade: '',
            sensitiveWords: [],
            fileSizeStr: '',
            raw: data
          };
          this.file_list.unshift(file);
          return true;
        } else {
          let index = this.file_list.indexOf(new_list[0]);
          this.file_list[index].message = this.$getText('wenshu_web_uploading', '上传中...');
          this.file_list[index].fileStatus = '';
          return true;
        }
      },
      before_file_remove(file) {
        let vm = this;
        return this.$mtd.confirm({
          title: this.$getText('wenshu_web_delete_file', '删除文件'),
          message: this.$getText('wenshu_web_confirm_remove', '确定移除') + `${file.fileName}？`,
          onOk: function () {
            vm.remove_file(file)
          }
        });
      },
      file_on_progress(event, file, _fileList) {
        let index = this.file_list.findIndex(item => item.uid === file.uid);
        this.file_list[index].percentage = event.percent;
      },
      handleUploadSuccess(response, file, _file_list) {
        let index = this.file_list.findIndex(item => item.uid === file.uid);
        if (response.code === 0) {
          this.file_list[index].message = file.response.message;
          this.file_list[index].id = response.data;
          setTimeout(() => {
            let newIndex = this.file_list.findIndex(item => item.uid === file.uid);
            this.file_list[newIndex].message = this.$getText('ws_mobile_analyzing', '分析中...');
            this.file_scan(response.data, this.file_list[newIndex].fileName);
          }, 500);
        } else {
          this.file_list[index].fileStatus = 'fail';
          this.file_list[index].message = this.$getText('wenshu_web_upload_failed', '上传失败');
          this.handleUploadError(response.message);
        }
      },
      handleUploadError(err) {
        for (let i = 0; i < this.file_list.length; i++) {
          if (this.file_list[i].status === 'fail') {
            this.file_list[i].fileStatus = 'fail';
            this.file_list[i].message = this.$getText('wenshu_web_upload_failed', '上传失败');
          }
        }
        if (err.type === 'error') {
          this.$mtd.message.error(this.$getText('wenshu_web_network_error', '网络错误'));
        } else {
          this.$mtd.message.error(this.$getText('wenshu_web_request_error', '请求出错') + err);
        }
      },
      // 文件扫描
      async file_scan(id, fileName) {
        let param = {id: id, fileName: fileName};
        await this.fileContentScan(param).then(res => {
          let index = this.file_list.findIndex(item => item.id === res.data.id + "");
          this.file_list[index].message = this.$getText('wenshu_web_analysis_complete', '分析完成');
          this.file_list[index].fileStatus = 'success';
          this.file_list[index].sourceFileName = res.data.sourceFileName;
          // 分析完成之后，请求策略匹配
          this.start_matching_strategy();
        });
      },
      remove_file(file) {
        let index = this.file_list.indexOf(file);
        this.file_list.splice(index, 1);
        this.$mtd.message({
          message: this.$getText('wenshu_web_deletion_successful', '删除成功'),
          type: 'success',
        });
        this.start_matching_strategy();
      },
      show_limit_message(_files, _fileList) {
        this.$mtd.message.error(this.$getText('wenshu_web_module_web_upload_limit', {max: this.max_limit}, '最多同时上传{max}个文件'));
      },
      clear_data() {
        this.file_list = [];
        this.email_list = [];
      },
      start_matching_strategy() {
        if (!this.file_list || this.file_list.length === 0) {
          this.reset_strategy_data();
          return;
        }
        // 如果其中有一个文件没有成功，就不能进行规则匹配
        for (let i = 0; i < this.file_list.length; i++) {
          let temp = this.file_list[i];
          if (temp.fileStatus === 'fail') {
            return;
          }
        }
        // 匹配策略
        this.matchingStrategy(this.file_list).then(res => {
          let emails = this.email_list.join(",");
          console.log(emails);
          // 如果有报错，提示报错信息
          if (res.code !== 0) {
            console.error(res);
            this.$mtd.message.error(res.message);
            return;
          }
          // 返回数据
          let result = res.data;
          if (result == null) {
            this.matching_strategy_result = null;
            this.exempt_approval_flag = false;
            this.strategy_chain_list = [];
            return;
          }
          // 判断是否是免审批
          let {currentStrategy, isExemption, refuseSendOut, hitFileIdList, templateContactPerson} = result;
          if (templateContactPerson && templateContactPerson !== '') {
            this.templateContactPerson = templateContactPerson;
          }

          if (refuseSendOut && hitFileIdList && hitFileIdList.length > 0) {
            this.current_refuse_send_out = true;
            this.current_refuse_send_file_list = hitFileIdList;
            for (let i = 0; i < this.file_list.length; i++) {
              let temp = this.file_list[i];
              if (hitFileIdList.indexOf(parseInt(temp.id)) !== -1) {
                temp.fileStatus = 'refuse';
                temp.message = this.$getText('wenshu_web_prohibit_forwarding', '禁止外发');
              } else {
                temp.fileStatus = 'success';
                temp.message = this.$getText('wenshu_web_analysis_complete', '分析完成');
              }
            }
          } else {
            for (let i = 0; i < this.file_list.length; i++) {
              let temp = this.file_list[i];
              temp.fileStatus = 'success';
              temp.message = this.$getText('wenshu_web_analysis_complete', '分析完成');
            }
            this.current_refuse_send_out = false;
            this.current_refuse_send_file_list = [];
          }
          if (this.current_refuse_send_out && this.current_refuse_send_file_list && this.current_refuse_send_file_list.length > 0) {
            this.strategy_chain_list = [];
            return;
          }
          if (!currentStrategy || currentStrategy.isExemption || isExemption) {
            this.exempt_approval_flag = true;
            this.strategy_chain_list = [];
            return;
          }
          // 返回数据不为空，需要添加审批流程
          this.matching_strategy_result = currentStrategy;
          this.exempt_approval_flag = false;
          // 加载所需要的审批链
          this.load_approval_chain();
        });
      },
      load_approval_chain() {
        // 去掉免审批场景
        if (this.exempt_approval_flag || !this.matching_strategy_result) {
          return;
        }
        let strategyId = this.matching_strategy_result.id;
        this.query_bpm_approval_chain({strategyId}).then((res) => {
          if (res.code !== 0) {
            console.error(res);
            this.$mtd.message.error(res.message);
            return;
          }
          this.strategy_chain_list = res.data;
        });
      },
      reset_strategy_data() {
        this.matching_strategy_result = null;
        this.exempt_approval_flag = false;
        this.strategy_chain_list = [];
        this.current_refuse_send_out = false;
        this.current_refuse_send_file_list = [];
        this.templateContactPerson = this.$getText('ws_mobile_employee_help_desk', '员工帮助台');
      },
      submit_out() {
        let emails = this.email_list.join(",");
        let submitParams = {
          emails,
          files: this.file_list,
          fileOutReason: this.outReason,
          validateDays: this.validateDays,
        }
        // 免审批的场景
        if (this.exempt_approval_flag || !this.matching_strategy_result) {
          this.submitFileOutOrderExemption(submitParams).then(res => {
            this.submit_success_redirect(res, emails);
          });
        } else {
          // 下面是需要审批的场景
          submitParams['id'] = this.matching_strategy_result.id;
          submitParams['strategyName'] = this.matching_strategy_result.strategyName;
          this.submitFileOutOrder(submitParams).then(res => {
            this.submit_success_redirect(res, emails);
          });
        }
      },
      submit_success_redirect(res, emails) {
        if (!res || res.code !== 0) {
          console.error(res);
          this.$mtd.message.error(this.$getText('ws_mobile_submit_failed', '提交失败'));
          return;
        }
        let shared = res.data;
        if (shared && shared.url) {
          let info = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + ` ${shared.url} \n` + this.$getText('ws_mobile_extract_password_text', '提取密码：') + `${shared.password}`;
          console.log(info);
        }
        this.$router.push({name: 'file_out_completed', params: {shared, emails}});
      },
      re_upload(file) {
        let index = this.file_list.indexOf(file);
        this.file_list[index].status = "ready";
        this.$refs.upload.submit();
      },
      pictureSelect(file) {
        let fileName = file.fileName;
        if (!fileName || fileName === '') {
          return 'usual';
        }
        let temp = fileName.split('.');
        if (!temp || temp.length === 0) {
          return 'usual';
        }
        let fileType = temp[temp.length - 1].toLowerCase();
        switch (fileType) {
          // 表格
          case 'xlsx':
          case 'xls':
            return 'excel';
          // word
          case 'doc':
          case 'docx':
            return 'word';
          // 压缩包
          case 'zip':
            return 'zip';
          // ppt
          case 'ppt':
          case 'pptx':
            return 'ppt';
          // pdf
          case 'pdf':
            return 'pdf';
          // 视频
          case 'avi':
          case 'mpg':
          case 'wmv':
          case 'mov':
          case 'mp4':
            return 'video';
          // 音频
          case 'mp3':
          case 'wma':
            return 'music';
          // 图片
          case 'png':
          case 'gif':
          case 'jpg':
          case 'jpeg':
            return 'picture';
          // 图片素材
          case 'psd':
            return 'PS';
          // 图片素材
          case 'sketch':
            return 'sketch';
          // numbers
          case 'numbers':
            return 'numbers';
          // keynote
          case 'keynote':
            return 'keynote';
          // ai
          case 'ai':
            return 'AI';
          default:
            return 'usual'
        }
      },
      upload_status_class(item) {
        if (item.fileStatus === 'success') {
          return 'upload-result-success'
        } else if (item.fileStatus === 'fail') {
          return 'upload-result-fail'
        } else if (item.fileStatus === 'refuse') {
          return 'upload-result-fail'
        } else {
          return 'upload-result-default'
        }
      },
      validateDays_change(val) {
        if (val === -1) {
          this.custom_validate_modal = true;
        } else {
          this.custom_validate_modal = false;
        }
      },
      close_custom_validate() {
        this.custom_validate_modal = false;
        this.custom_form.custom_validate = null;
        this.validateDays = 3;
      },
      submit_custom_validate() {
        let insert = true;
        let custom_validate = this.custom_form.custom_validate;
        for (let i = 0; i < this.default_days.length; i++) {
          let tmp = this.default_days[i];
          if (tmp.value === custom_validate) {
            insert = false;
            break;
          }
        }
        if (insert) {
          this.default_days.push({value: custom_validate, label: custom_validate + '天'});
          this.validateDays = custom_validate;
        }
        this.custom_validate_modal = false;
        this.custom_form.custom_validate = null;
      },
      open_wenshu_client() {
        let wenshu_host_url = "https://cryptbox.sankuai.com/launch_client";
        if (window.location.host.indexOf(".test.") !== -1) {
          wenshu_host_url = "https://cryptbox.sec.test.sankuai.com/launch_client";
        }
        window.open(wenshu_host_url, "_blank");
      }
    }
  }
</script>

<style>

  #file-outgoing-container {
    margin-bottom: 80px;
  }

  .padding-left-0 {
    padding-left: 0 !important;
  }

  .padding-right-0 {
    padding-right: 0 !important;
  }

  .margin-bottom-0 {
    margin-bottom: 0;
  }

  .dd-page-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 32px;
    font-weight: 500;
  }

  .dd-page-subtitle {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.84);
    line-height: 22px;
    font-weight: 500;
  }

  .page-info-detail {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.36);
    line-height: 20px;
    font-weight: 400;
    margin-left: 10px;
  }

  h2.file-list-title {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .mtd-progress .mtd-progress-percentage {
    display: none;
  }

  .mtd-progress .mtd-progress-bar {
    padding-right: 0;
    margin-right: 0;
    margin-bottom: 3px;
  }

  .icon-btn {
    font-size: 16px;
    margin-right: 8px;
    float: right;
    padding: 0;
  }

  .icon-file-name {
    width: 100%;
    height: 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.84);
    line-height: 22px;
    position: absolute;
    top: 12px;
    flex-direction: row;
  }

  .mtd-icon-btn {
    width: 22px;
    height: 22px;
  }

  .margin-top-20 {
    height: 100%;
    top: -50px;
  }

  .full-height-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .result-success {
    border-color: #00B365;
  }

  .result-fail {
    border-color: #F5483B;
  }

  .mtd-upload-dragger {
    height: 136px;
  }

  .mtd-upload-dragger.drag-over {
    background: rgba(239, 248, 255, 0.50);
    border: 1px dashed #0A70F5;
    border-radius: 4px;
  }

  .mtd-upload-dragger, .drag-upload, .mtd-upload {
    text-align: center;
    width: 100%;
  }

  .upload-content {
    height: 136px;
  }

  .file-container-block {
    min-width: 160px;
  }

  .upload-content .mtd-upload-text .title-text {
    margin-top: 32px;
    margin-bottom: 16px;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.60);
    line-height: 22px;
    font-weight: 400;
  }

  .upload-content .mtd-upload-text .tips {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.36);
    text-align: center;
    line-height: 17px;
    font-weight: 400;
  }

  .mtd-upload-dragger {
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .mtd-message {
    min-width: 20px;
    padding: 6px 16px;
  }

  .el-input__inner {
    border-radius: 4px;
  }


  .file-extra {
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 4px;
    margin-bottom: 8px;
  }

  .file-extra-content {
    padding: 12px 16px;
  }

  .mtd-collapse-item-header {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .mtd-collapse-item-content {
    padding: 0;
  }

  .file-item-block {
    height: 44px;
    opacity: 0.8;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 2px;
  }

  .file-type-icon {
    width: 26px;
    height: 42px;
    text-align: center;
    vertical-align: middle;
    padding-top: 10px;
    float: left;
  }

  .file-type-icon img {
    height: 22px;
  }

  .progress-status-container {
    width: calc(100% - 56px);
    height: 42px;
    float: left;
    padding: 5px 0;
  }

  .progress-status-container .file-name-div {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.84);
    line-height: 14px;
    font-weight: 500;
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .progress-status-container .progress-div {
    margin-top: 4px;
    height: 14px;
  }

  .upload-result-default {
    color: #0A70F5;
  }

  .upload-result-success,
  .upload-result-success .file-upload-progress,
  .upload-result-success .file-upload-show-text {
    color: #00B365 !important;
    opacity: 1 !important;
  }

  .upload-result-fail,
  .upload-result-fail .file-upload-progress,
  .upload-result-fail .file-upload-show-text {
    color: #DD3429 !important;
    opacity: 1 !important;
  }

  .progress-status-container .progress-div .mtdicon-bolt-fill {
    float: left;
  }

  .progress-status-container .progress-div .file-upload-progress {
    width: calc(100% - 120px);
    display: inline-block;
    float: left;
    border: none;
  }

  .progress-status-container .progress-div .file-upload-show-text {
    opacity: 0.5;
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.84);
    font-weight: 500;
    line-height: 14px;
    display: inline-block;
    margin-left: 4px;
    float: left;
  }

  .delete-file-container {
    width: 30px;
    height: 42px;
    float: right;
    padding: 11px 5px;
  }

  .delete-file-container .mtd-icon-btn {
    width: 20px;
    height: 20px;
    padding: 0;
  }

  .submit-buttons-div {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 64px;
    padding: 12px 0;
    text-align: center;
    border-top: 1px #E0E0E0 solid;
    left: 0;
    background-color: #fff;
    z-index: 999;
  }

</style>
